export default "__VITE_ASSET__B9256rmE__"